var ShopReviewsListing = (function ($) {

    var pageNumber = 2;
    var isNowLoading = false;
    var endOfResults = false;
    var numberOfItemsAutoLoaded = 0; // number of elements loaded automatically before calling the "load more" action. This resets to 0 each time "load more" button is called
    var totalNumberOfItemsLoaded = 0; // total number of items loaded on the page
    var totalNumberOfItems = 0; // total number of results the search generated that can be loaded
    var showLoadMoreButtonAfter = 0; // number of items to load before displaying the "load more" button. This resets to 0 each time "load more" button is called
    var itemsPerPage = 0;
    var errorsCount = 0;

    var itemsPerPageSel = '#jReviewsPerPage';
    var searchResultItemSel = '.j-sr-item';
    var totalResultsSel = '#jTotalReviews';
    var showLoadMoreBtnSel = '#jShowLoadMoreButtonAfterCountReviews';

    var bottomAreaSel = '.j-bottom-area-reviews-list';
    var loadMoreResultsSel = '.j-load-more-reviews';
    var loadErrorSel = '.j-load-error-reviews-list';


    var initContinuousScroll = function () {
        itemsPerPage = parseInt($(itemsPerPageSel).val());
        numberOfItemsAutoLoaded = parseInt($(searchResultItemSel).length);
        totalNumberOfItems = parseInt($(totalResultsSel).val());
        totalNumberOfItemsLoaded = numberOfItemsAutoLoaded;
        showLoadMoreButtonAfter = parseInt($(showLoadMoreBtnSel).val());
        endOfResults = totalNumberOfItemsLoaded === totalNumberOfItems;

        if ($(window).scrollTop() > 150) {
            $(window).trigger('scroll');
        }

        $(window).on('scroll', function() {
            if(isScrolledIntoView(bottomAreaSel) && !isNowLoading && !endOfResults && (numberOfItemsAutoLoaded <= showLoadMoreButtonAfter)) {
                fetchData(bottomAreaSel, loadErrorSel);
            }

            if (numberOfItemsAutoLoaded > showLoadMoreButtonAfter && !endOfResults) {
                $(loadMoreResultsSel).show();
            }

            $(loadMoreResultsSel).off().on('click', function () {
                numberOfItemsAutoLoaded = 0;
                fetchData(bottomAreaSel, loadErrorSel);
                $(loadMoreResultsSel).hide();
            });

        });

        $(loadErrorSel).on('click', function () {
            location.reload();
        });
    };

    var fetchData = function (bottomAreaSel, loadErrorSel) {

        var url = ACC.config.contextPath + "/shopReviewsFragment/" + pageNumber;

        showLoadingImage(bottomAreaSel);
        isNowLoading = true;

        MainJS.untrackedAjaxCall(url, "GET", "", function (data) {
            if (data) {
                errorsCount = 0;
                $(bottomAreaSel).before($(data).not(totalResultsSel));
                numberOfItemsAutoLoaded += parseInt($(data).filter(searchResultItemSel).length);
                if (numberOfItemsAutoLoaded !== 0) {
                    pageNumber += 1;
                }
                totalNumberOfItemsLoaded = parseInt($(searchResultItemSel).length);
                endOfResults = totalNumberOfItems === totalNumberOfItemsLoaded;
                hideLoadingImage(bottomAreaSel);
                isNowLoading = false;
            } else {
                errorsCount++;
                if (errorsCount === 1) {
                    numberOfItemsAutoLoaded = 0;
                    fetchData(bottomAreaSel, loadErrorSel);
                    $(loadMoreResultsSel).hide();
                } else {
                    hideLoadingImage(bottomAreaSel);
                    $(loadErrorSel).show();
                    endOfResults = true;
                }
            }
        }, function () {
            hideLoadingImage(bottomAreaSel);
            $(loadErrorSel).show();
        }, {});
    };

    var isScrolledIntoView = function (elem) {
        var $elem = $(elem);
        var $window = $(window);

        var docViewTop = $window.scrollTop();
        var docViewBottom = docViewTop + $window.height();

        var elemTop = $elem.offset().top;
        var elemBottom = elemTop + $elem.height();

        return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
    };

    var showLoadingImage = function () {
        $('.j-bottom-area-reviews-list > .ajax-loader-128-gif').show();
    };

    var hideLoadingImage = function () {
        $('.j-bottom-area-reviews-list > .ajax-loader-128-gif').hide();
    };

    return {
        initContinuousScroll: initContinuousScroll
    }
}) (jQuery);

$(document).ready(function() {
    if (typeof ($('#jTotalReviews').val()) !== 'undefined') {
        ShopReviewsListing.initContinuousScroll();
    }
});